import { TFlatType, TOfferCategory } from '@cian/chats-api';

import { FDealType, getDealType } from './deal_type';
import { FlatType, FOfferType, getOfferType, isFlat, isSuburban } from './offer_type';
import { TOfferExtra } from '../types/offer';

const mapDealType = {
  [FDealType.RentDaily]: 'rent_day',
  [FDealType.RentLongterm]: 'rent_long',
  [FDealType.Rent]: 'rent_long',
  [FDealType.Sale]: 'sale',
  [FDealType.Unexpected]: 'sale',
  [FDealType.Any]: 'sale',
};

export type TOfferProductsProps = {
  newbuilding?: {
    showJkReliableFlag?: boolean;
  };
  gaGeo?: {
    moId?: number;
    oblId?: number;
    cityId?: number;
  };
  dealType: string;
  category: TOfferCategory;
  offerType: string;
  id: number;
  photos?: {
    isDefault?: boolean;
    miniUrl?: string;
  }[];
  roomsCount?: number;
  flatType?: TFlatType;
  analyticsUrl?: string;
};

export function getCustomUrl(offer: TOfferProductsProps) {
  // В новой версии есть отдельное поле
  if (offer.analyticsUrl) {
    return offer.analyticsUrl;
  }
  const { dealType, category, offerType } = offer;

  const params: Array<string | undefined | boolean | number> = [];

  if (offer.gaGeo) {
    params.push(offer.gaGeo.moId && `mo_id=${offer.gaGeo.moId}`);
    params.push(offer.gaGeo.oblId && `obl_id=${offer.gaGeo.oblId}`);
    params.push(offer.gaGeo.cityId && `city_id=${offer.gaGeo.cityId}`);
  }

  params.push(dealType);
  params.push(offerType);
  params.push(geTrackingObjectType(dealType, category));
  params.push(getTrackingObjType(offer));
  params.push(getRentType(offer));
  params.push(offer.id);

  return `/${params.filter(Boolean).join('/')}/`;
}

function geTrackingObjectType(dealType: string, category: string) {
  if (dealType === 'sale') {
    const offerCategory = category.toLowerCase();

    if (offerCategory.includes('flat') && offerCategory.includes('newbuilding')) {
      return 'object_type=2';
    } else {
      return 'object_type=1';
    }
  }

  return 'object_type=';
}

function getTrackingObjType(offer: TOfferProductsProps): string | undefined {
  const offerType = getOfferType(offer);

  if (offerType === FOfferType.Bed) {
    return 'ga_obj_type=10';
  }

  if (offerType === FOfferType.Room) {
    return 'ga_obj_type=0';
  }

  if (isFlat(offerType)) {
    if (offer.flatType === FlatType.OpenPlan) {
      return 'ga_obj_type=7';
    }

    if (offer.flatType === FlatType.Studio) {
      return 'ga_obj_type=9';
    }

    if (offer.roomsCount && offer.roomsCount > 0 && offer.roomsCount < 6) {
      return `ga_obj_type=${offer.roomsCount}`;
    }

    if (offer.roomsCount && offer.roomsCount >= 6) {
      return 'ga_obj_type=6';
    }
  }

  if (isSuburban(offerType)) {
    if (offerType === FOfferType.House) {
      return 'ga_obj_type=1';
    }

    if (offerType === FOfferType.HousePart) {
      return 'ga_obj_type=2';
    }

    if (offerType === FOfferType.Land) {
      return 'ga_obj_type=3';
    }

    if (offerType === FOfferType.Townhouse) {
      return 'ga_obj_type=4';
    }
  }

  return undefined;
}

function getRentType(offer: TOfferProductsProps): string | undefined {
  const dealType = getDealType(offer);

  if (dealType === FDealType.RentDaily) {
    return 'rent_type=daily';
  }

  if (dealType === FDealType.RentLongterm) {
    return 'rent_type=long';
  }

  return undefined;
}

export const getCategory = (offer: TOfferProductsProps): string => {
  //category
  const dealType = getDealType(offer);
  //category
  const offerType = getOfferType(offer);

  let offerTypeStr;
  if (offerType === FOfferType.FlatOld) {
    offerTypeStr = 'flat_old';
  } else if (offerType === FOfferType.FlatNew) {
    offerTypeStr = 'flat_new';
  } else if (offerType & FOfferType.Commercial) {
    offerTypeStr = 'commercial';
  } else if (offerType & FOfferType.Suburban) {
    offerTypeStr = 'suburban';
  } else {
    offerTypeStr = 'flat_old,flat_new';
  }

  return `${mapDealType[dealType]}/${offerTypeStr}`;
};

function getDealTypeSopr(offer: TOfferProductsProps) {
  //category
  const dealType = getDealType(offer);

  return mapDealType[dealType];
}

export function getProducts(offers: TOfferProductsProps[], extra?: TOfferExtra) {
  return offers.map((offer, index) => {
    return {
      category: getCategory(offer),
      dealType: getDealTypeSopr(offer),
      offerType: 'offer',
      id: offer.id,
      /**
       * objectType вторая часть от category
       */
      objectType: getCategory(offer).split('/')[1],
      photosCount: (offer.photos || []).length,
      position: index + 1,
      /**
       * Всегда 1
       */
      quantity: 1,
      extra,
    };
  });
}
